import createIcon from '../../createIcon';

/**
 * @component @name Segment
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOSAxOEgyMVYxNkg5VjE4Wk0zIDZWOEgyMVY2SDNaTTkgMTNIMjFWMTFIOVYxM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Segment = createIcon('Segment', [
  ['path', { d: 'M9 18H21V16H9V18ZM3 6V8H21V6H3ZM9 13H21V11H9V13Z', key: '612nan' }],
]);

export default Segment;
